var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtendimentoPulicoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 29.5833H21.25V24.5833H26.25V22.0833H21.25V17.0833H18.75V22.0833H13.75V24.5833H18.75V29.5833ZM5.83333 36.6667C5.16667 36.6667 4.58333 36.4167 4.08333 35.9167C3.58333 35.4167 3.33333 34.8333 3.33333 34.1667V11.9583C3.33333 11.2917 3.58333 10.7083 4.08333 10.2083C4.58333 9.70833 5.16667 9.45833 5.83333 9.45833H13.75V5.83333C13.75 5.16666 14 4.58333 14.5 4.08333C15 3.58333 15.5833 3.33333 16.25 3.33333H23.75C24.4167 3.33333 25 3.58333 25.5 4.08333C26 4.58333 26.25 5.16666 26.25 5.83333V9.45833H34.1667C34.8333 9.45833 35.4167 9.70833 35.9167 10.2083C36.4167 10.7083 36.6667 11.2917 36.6667 11.9583V34.1667C36.6667 34.8333 36.4167 35.4167 35.9167 35.9167C35.4167 36.4167 34.8333 36.6667 34.1667 36.6667H5.83333ZM16.25 9.45833H23.75V5.83333H16.25V9.45833ZM5.83333 34.1667H34.1667V11.9583H5.83333V34.1667ZM5.83333 11.9583V34.1667V11.9583Z",
    fill: "#337066"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtendimentoPulicoIcon);
export default __webpack_public_path__ + "static/media/atendimento_pulico_icon.82f237d736ada083e86322e393578fad.svg";
export { ForwardRef as ReactComponent };